<template>
    <div>
    <div class="page page-careers d-flex" id="careers">

        <page-header class="careers-header"/>
        <side-nav class="careers-side-nav"/>
        <div class="row align-items-end w-100 no-gutters">
            <!-- Medium width and larger screens -->
            <div class="d-none d-md-block col-10 col-sm-6 offset-1 offset-sm-3">

                <p class="why why-work-at-livio-w" ><b><h1>Why work at Livio?</h1></b></p>
                <p class="why">We're a small office with a startup culture, and at the same time, have all the benefits of being a wholly-owned subsidiary of Ford Motor Co.</p>

                <p class="why">Flexible hours, health, dental, vision, Ford Retirement Plan, and 401K.</p>
                <div class="row align-items-center justify-content-center d-flex w-100 careers">
                    <a v-for="career in careers" class="card-career" v-bind:href="career.url" target="_blank">
                        <p class="title">{{ career.title }} - {{ career.subtext }}</p>
                        <span v-for="requirement in career.requirements" class="requirement">{{ requirement }}</span>
                    </a>
                </div>
                <div v-if="careers.length === 0" class="why no-available-positions">Please check back for available positions.</div>
            </div>
            <!-- Small width screens -->
            <div class="d-md-none d-sm-block why-block">

                <p class="why why-work-at-livio-w" ><b><h1>Why work at Livio?</h1></b></p>
                <p class="why">We're a small office with a startup culture, and at the same time, have all the benefits of being a wholly-owned subsidiary of Ford Motor Co.</p>

                <p class="why">Flexible hours, health, dental, vision, Ford Retirement Plan, and 401K.</p>
                <div class="row align-items-center justify-content-center d-flex w-100 careers">
                    <a v-for="career in careers" class="card-career" v-bind:href="career.url" target="_blank">
                        <p class="title">{{ career.title }} - {{ career.subtext }}</p>
                        <span v-for="requirement in career.requirements" class="requirement">{{ requirement }}</span>
                    </a>
                </div>
                <div v-if="careers.length === 0" class="why no-available-positions">Please check back for available positions.</div>
            </div>
            <!--div class="w-100"></div-->
            <div class="offset-1 col-10">
                <div class="align-items-bottom justify-content-between text-center d-flex w-100 team">
                    <img class="livio-illustration" src="../../static/images/1x/skyline.png" srcset="../../static/images/2x/skyline@2x.png 2x, ../../static/images/3x/skyline@3x.png 3x" />
                </div>
            </div>
        </div>
    </div>
    </div>
</template>
<script>

import Header from './shared/Header.vue'
import Footer from './shared/Footer.vue'
import SideNav from './shared/SideNav.vue'
export default {
    data () {
        return {
            /**
             * careers - An array of JSON objects with details on a position
             * 
             * JSON fields:
             * title - ex. Mobile Software Engineer
             * subtext - The respective team (ex. iOS)
             * requirements - Relevant programming languages (ex. Swift, Swift UI, Objective-C)
             * url - Ford link to the application
             */
            "careers": [
            ],
        }
    },
    components: {
        "page-footer": Footer,
        "page-header": Header,
        "side-nav": SideNav,
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Careers.vue